import { Github } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-gray-800 bg-gray-950 py-12 text-gray-400">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8 grid gap-8 md:grid-cols-4">
          <div>
            <div className="mb-4 flex items-center gap-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-blue-500 to-emerald-500 p-1">
                <svg
                  viewBox="0 0 100 100"
                  fill="none"
                  className="h-full w-full"
                >
                  {/* Gordian Knot - Complex interwoven path */}
                  <path
                    d="M50 10 C 65 10, 75 20, 75 35 C 75 42, 72 48, 65 52 C 72 56, 75 62, 75 69 C 75 84, 65 94, 50 94 C 35 94, 25 84, 25 69 C 25 62, 28 56, 35 52 C 28 48, 25 42, 25 35 C 25 20, 35 10, 50 10 Z"
                    stroke="white"
                    strokeWidth="3"
                    fill="none"
                    opacity="0.9"
                  />
                  <path
                    d="M 30 30 C 40 25, 60 25, 70 30 M 70 30 C 75 40, 75 60, 70 70 M 70 70 C 60 75, 40 75, 30 70 M 30 70 C 25 60, 25 40, 30 30"
                    stroke="white"
                    strokeWidth="3"
                    fill="none"
                    opacity="0.7"
                  />
                  {/* Crossing loops */}
                  <path
                    d="M 38 25 Q 50 35, 62 25 M 38 75 Q 50 65, 62 75"
                    stroke="white"
                    strokeWidth="2.5"
                    fill="none"
                    opacity="0.85"
                  />
                  <path
                    d="M 25 38 Q 35 50, 25 62 M 75 38 Q 65 50, 75 62"
                    stroke="white"
                    strokeWidth="2.5"
                    fill="none"
                    opacity="0.85"
                  />
                  {/* Center weave */}
                  <ellipse
                    cx="50"
                    cy="50"
                    rx="12"
                    ry="18"
                    stroke="white"
                    strokeWidth="2.5"
                    fill="none"
                    opacity="0.8"
                  />
                  <ellipse
                    cx="50"
                    cy="50"
                    rx="18"
                    ry="12"
                    stroke="white"
                    strokeWidth="2.5"
                    fill="none"
                    opacity="0.8"
                  />
                </svg>
              </div>
              <span className="text-xl text-white">Brenneman Systems</span>
            </div>
            <p className="text-gray-500">
              Connecting systems, automating workflows, and transforming
              businesses.
            </p>
          </div>

          <div>
            <h3 className="mb-4 text-white">Offers</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#services"
                  className="transition-colors hover:text-blue-400"
                >
                  GoHighLevel Setup
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="transition-colors hover:text-blue-400"
                >
                  Business Automation
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="transition-colors hover:text-blue-400"
                >
                  Automation Audit
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="transition-colors hover:text-blue-400"
                >
                  Local LLM Setup
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-white">Company</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="transition-colors hover:text-blue-400">
                  About Us
                </a>
              </li>
              <li>
                <a href="#" className="transition-colors hover:text-blue-400">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-white">Connect</h3>
            <div className="flex gap-4">
              <a
                href="#"
                className="flex h-10 w-10 items-center justify-center rounded-lg bg-gray-900 transition-all hover:bg-gradient-to-br hover:from-blue-500 hover:to-emerald-500"
              >
                <Github className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-gray-800 pt-8 md:flex-row">
          <p className="text-gray-500">
            © 2025 Brenneman Systems. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a
              href="#"
              className="text-gray-500 transition-colors hover:text-blue-400"
            >
              Privacy Policy
            </a>
            <a
              href="#"
              className="text-gray-500 transition-colors hover:text-blue-400"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
